import React from 'react';

const PlusIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
  </svg>
);

const PILL =
  'inline-flex items-center gap-1 bg-purple-500/20 hover:bg-purple-500/40 border border-purple-400/40 text-purple-100 text-xs font-medium px-2 py-1 rounded-full transition-colors duration-200';

// The gap between two cards, and the only things in it: a button that adds a
// question there and one that starts a section there. They stay out of sight
// until the pointer is in the gap — an author reading a form down the page
// shouldn't have to read past controls in every space between questions — and
// they are inert while hidden, so they can't swallow a click meant for the card
// above or below.
//
// The gap is sized to hold the pills outright rather than to the blank space a
// list needs between cards: at anything shorter the buttons spill over the
// cards on either side of them, landing on top of whatever they have near that
// edge.
//
// `place` finishes both labels — "here", or "inside “Roof”, here" — so each
// button says where the new card will land.
const InsertRow = ({ onAddQuestion, onAddSection, place }) => (
  <div className="group/insert relative h-8">
    <div className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center gap-2 opacity-0 transition-opacity duration-150 group-hover/insert:pointer-events-auto group-hover/insert:opacity-100 group-[:has(:focus-visible)]/insert:pointer-events-auto group-[:has(:focus-visible)]/insert:opacity-100">
      <button
        type="button"
        onClick={onAddQuestion}
        title={`Add a question ${place}`}
        aria-label={`Add a question ${place}`}
        className={PILL}
      >
        <PlusIcon />
        Question
      </button>
      <button
        type="button"
        onClick={onAddSection}
        title={`Start a section ${place}`}
        aria-label={`Start a section ${place}`}
        className={PILL}
      >
        <PlusIcon />
        Section
      </button>
      <span className="h-px flex-1 bg-purple-500/30" aria-hidden="true" />
    </div>
  </div>
);

export default InsertRow;
